export const state = {
    tasks: [],
};
